import { useMap } from 'react-leaflet';

export function SetViewOnRender({ coords, center}) {
    const map = useMap();
    map.setView(coords, map.getZoom());
    return null;
}